
class mapDataEntity {
    total
    data
    updatedAt
    constructor() {
        this.total = 0;
        this.updatedAt = Date.now();
    }
}


class SectorEntity {
    rev
    industries
    scale
    color
    deleted
    updatedAt
    type

    constructor( id, title ) {
        this.rev = 1;
        this.deleted = false;
        this.industries = [];
        this.scale = 0;
        this.color = 0;
        this.updatedAt = Date.now();
        this.type = 'sector';
        this.id = id;
        this.title = title;
    }
}




class IndustryEntity {
    rev
    tickers
    scale
    color
    deleted
    updatedAt
    type
    isin

    constructor( id, title, isin) {
        this.rev = 1;
        this.deleted = false;
        this.tickers = [];
        this.scale = 0;
        this.isin = isin;
        this.color = 0;
        this.updatedAt = Date.now();
        this.type = 'industry';
        this.id = id;
        this.title = title;
    }
}

class TickerEntity {
    rev
    deleted
    updatedAt
    type
    color
    id
    names
    exchange
    namePouya
    namePouyaFa
    symbolPouya
    symbolPouyaFa
    price
    scale
    symbol
    title
    url

    constructor( id, title, symbol, scale, color, price, url) {
        this.rev = 1;
        this.deleted = false;
        this.updatedAt = Date.now();
        this.type = 'ticker';
        this.id = id;
        this.title = title
        this.symbol = symbol
        this.scale = scale
        this.color = color
        this.price = price
        this.url = url
    }
}


const D = {
    style : [
        { color: '#30cc5a', value: 3 },
        { color: '#2f9e4f', value: 2 },
        { color: '#35764e', value: 1 },
        { color: '#414554', value: 0 },
        { color: '#8b444e', value: -1 },
        { color: '#bf4045', value: -2 },
        { color: '#f63538', value: -3 },
    ],
    naColor:'#000000'
}




export function parseData(arr, showNA) {
    let mapData = new mapDataEntity();
    mapData.data = [];
    console.log(arr)
    for (let sector of arr) {
        let sectorId = sector.id;
        let sectorTitle = sector.title.toUpperCase();
        let sectorIndustries = sector.industries;
        let _sector = new SectorEntity(sectorId, sectorTitle);
        let sectorColor = 0;

        for (let industry of sectorIndustries) {
            let industryId = industry.id;
            let industryIsin = null //industry.isin;
            let industryTitle = industry.title.toUpperCase();
            let industryTickers = industry.tickers;
            let _industry = new IndustryEntity(industryId, industryTitle, industryIsin);
            _sector.industries.push(_industry);
            let industryColor = 0;

            for (let ticker of industryTickers) {
                let tickerId = ticker.id;
                let tickerTitle = ticker.title;
                let tickerSymbol = ticker.symbol;
                let tickerScale = ticker.scale;
                let tickerColor = ticker.color;
                let tickerPrice = ticker.price;
                let tickerUrl = ticker.url;
                let _ticker = new TickerEntity(tickerId, tickerTitle, tickerSymbol, tickerScale, tickerColor, tickerPrice, tickerUrl);
                if(!showNA){if(!isNaN(ticker.color)){_industry.tickers.push(_ticker)}}
                else {_industry.tickers.push(_ticker)}
                _industry.scale += _ticker.scale;
                if (!isNaN(ticker.color)) industryColor += _ticker.color;
            }
            _sector.scale += _industry.scale;
            _industry.color = industryColor
            sectorColor += industryColor;
        }
        _sector.color = sectorColor
        mapData.total += _sector.scale;
        mapData.data.push(_sector);
    }
    //console.log('mapData ----- ',mapData)

    return mapData;
}





export function mapFetchedData(data, quotes) {
    //data tickers: tickerkey, close, value, return 1 day
    //quotes : ticker_pooya_fa, ticker_key, sector index, industry index
    let sectors = []
    if(!quotes){
        return sectors;
    }
    let _quotes = quotes.split(",");
    for(var s = 0 ; s < data.sectors.length; s++){
        let sector = {};
        sector['title'] = data.sectors[s];
        sector['id'] = data.sectors[s];
        sector['scale'] = null;
        sector['industries'] = [];

        for(var i = 0 ; i < data.industries.length - 1 ; i+=2){
            let industrieTitle = data.industries[i];
            let iSectorIndex = data.industries[i+1];
            if(typeof iSectorIndex === 'number' && s === iSectorIndex){
                let industrie = {};
                industrie['title'] = industrieTitle;
                industrie['id'] = industrieTitle;
                industrie['color'] = null;
                industrie['scale'] = null;
                industrie['tickers'] = []
                sector['industries'].push(industrie);

                for(var t = 0 ; t < data.tickers.length ; t+=4){
                    let tickerTitle = data.tickers[t];
                    let ticker_key = data.tickers[t+1];
                    let tSectorIndex = data.tickers[t+2];
                    let tIndustrieIndex = data.tickers[t+3];
                    if(typeof tickerTitle === 'string' && s === tSectorIndex && i === tIndustrieIndex * 2){
                        let ticker = {};
                        ticker['title'] = tickerTitle;
                        ticker['symbol'] = tickerTitle;
                        ticker['id'] = tickerTitle;
                        ticker['names'] = [];
                        for(var q = 0 ; q < _quotes.length ; q+=4){
                            let tickerkey = _quotes[q];
                            let close = _quotes[q+1] ? parseFloat(_quotes[q+1]) : '';
                            let value = _quotes[q+2] ? parseFloat(_quotes[q+2]) : '';
                            let returnDay = parseFloat(_quotes[q+3]);
                            if(ticker_key.toString() === tickerkey){
                                ticker['price'] = close;
                                ticker['scale'] = value;
                                ticker['color'] = returnDay;
                                industrie['tickers'].push(ticker)
                            }
                        }
                    }
                }
           }
        }
        sectors.push(sector)
    }
    //console.log('sectors ----- ',sectors)

    return sectors;
}


export let formatBMK = (n) => {
    let abs = Math.abs(n);
    let value = abs > 1000000000 ? n / 1000000000 : abs > 1000000 ? n / 1000000 : abs > 1000 ? n / 1000 : n;
    let suffix = abs > 1000000000 ? ' B' : abs > 1000000 ? ' M' : abs > 1000 ? ' K' : ' ';
    return separateString(value>100?value.toFixed(0):value.toFixed(1), 3, ',') + suffix;
}

//separate number by seperator
let separateString = (data, interval, delimiter) => {
    let regex = new RegExp('\\B(?=(\\d{' + interval + '})+(?!\\d))', 'g');
    return data.toString().replace(regex, delimiter);
}


// //get color
export function getColor(v) {
    if (isNaN(v)) return D.naColor;
    if (D.numType ==='percent') v *= 100;
    if (v >= D.style[0].value) return D.style[0].color
    for (let i = 1; i < D.style.length; i++) {
        if (v >= D.style[i].value) {
            let ratio = (D.style[i - 1].value - v) / (D.style[i - 1].value - D.style[i].value);
            return colorMixer(hexToRgb(D.style[i - 1].color), hexToRgb(D.style[i].color), ratio);
        }
    }
    return D.style[D.style.length - 1].color;
}

function hexToRgb(hex) {
    let c = [];
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        let cc = '0x' + c.join('');
        return [(cc >> 16) & 255, (cc >> 8) & 255, cc & 255];
    }
    throw new Error('Bad Hex');
}

function colorMixer(rgbA, rgbB, ratio) {
    var r = colorChannelMixer(rgbA[0], rgbB[0], ratio);
    var g = colorChannelMixer(rgbA[1], rgbB[1], ratio);
    var b = colorChannelMixer(rgbA[2], rgbB[2], ratio);
    return "rgb(" + r + "," + g + "," + b + ")";
}

function colorChannelMixer(colorChannelA, colorChannelB, ratio) {
    var channelA = colorChannelA * (1 - ratio);
    var channelB = colorChannelB * (ratio);
    return Math.round(channelA + channelB);
}

